export const handleApiError = error => {
  let message = "Something went wrong";

  const status = error?.response?.status;

  if (error?.response?.data?.errors) {
    const errors = error.response.data.errors;
    const firstKey = Object.keys(errors)[0];
    message = errors[firstKey][0];
  } else if (error?.response?.data?.Message) {
    message = error.response.data.Message;
  } else if (error?.response?.data?.message) {
    message = error.response.data.message;
  }

  // Handle server status codes
  else if (status) {
    switch (status) {
      case 404:
        message = "The requested resource could not be found. Please check the link or contact support.";
        break;

      case 400:
        message = "Bad request. Please check the entered data.";
        break;

      case 415:
        message = "Unsupported media type. The server cannot process the request format.";
        break;

      case 500:
        message = "Internal server error. Something went wrong on our side. Please try again later.";
        break;

      case 401:
        message = "Unauthorized access. Please login again to continue.";
        break;

      case 403:
        message = "Access denied. You do not have permission to perform this action.";
        break;

      default:
        message = `Unexpected server error (Status Code: ${status}).`;
    }
  } else if (error?.message) {
    message = error.message;
  }

  return {
    type: "error",
    message,
    openToast: true,
  };
};

// export const handleApiError = error => {
//   let message = "Something went wrong";

//   if (error?.response?.data?.errors) {
//     const errors = error.response.data.errors;

//     const firstKey = Object.keys(errors)[0];
//     message = errors[firstKey][0];
//   } else if (error?.message) {
//     message = error.message;
//   } else if (error?.response?.data?.Message) {
//     message = error.response.data.Message;
//   } else if (error?.response?.data?.message) {
//     message = error.response.data.message;
//   }

//   return {
//     type: "error",
//     message,
//     openToast: true,
//   };
// };
